import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "busy-indicator-container"
}
const _hoisted_2 = { class: "fixed-3x" }
const _hoisted_3 = { class: "fixed-3x" }
const _hoisted_4 = { class: "fixed-3x" }
const _hoisted_5 = { class: "fixed-3x" }

import { onMounted, ref } from 'vue'

import BusyIndicator from '@/components/common/BusyIndicator.vue'
import NotificationBanner from '@/components/common/NotificationBanner.vue'
import ScrollableTable from '@/components/common/ScrollableTable.vue'
import { useFarmClubDealsStore } from '@/store/public/farm-club-deals'
import { getErrorMessage } from '@/utils/error-handling'
import { formatDate, formatValue } from '@/utils/format'


export default /*@__PURE__*/_defineComponent({
  __name: 'FarmClubDealsView',
  setup(__props) {

const farmClubDeals = useFarmClubDealsStore()

const errorMessage = ref<string | null>(null)
const isLoading = ref<boolean>(false)

async function fetchFarmClubDeals(): Promise<void> {
  isLoading.value = true

  try {
    await farmClubDeals.fetch()
  } catch (e) {
    const message = getErrorMessage(e as Error)
    console.error(`Failed fetching farm club deals: ${message}`)
    errorMessage.value = message
  }

  isLoading.value = false
}

onMounted(fetchFarmClubDeals)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('farm-club-deals.heading')), 1),
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_1, [
          _createVNode(BusyIndicator)
        ]))
      : (errorMessage.value)
        ? (_openBlock(), _createBlock(NotificationBanner, {
            key: 1,
            message: errorMessage.value,
            "is-danger": ""
          }, null, 8, ["message"]))
        : (_unref(farmClubDeals).deals.length === 0)
          ? (_openBlock(), _createBlock(NotificationBanner, {
              key: 2,
              message: _ctx.$t('farm-club-deals.no-deals')
            }, null, 8, ["message"]))
          : (_openBlock(), _createBlock(ScrollableTable, { key: 3 }, {
              default: _withCtx(() => [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('farm-club-deals.bowler')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('farm-club-deals.own-club')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('farm-club-deals.farm-club')), 1),
                    _createElementVNode("th", _hoisted_2, _toDisplayString(_ctx.$t('farm-club-deals.valid-from')), 1),
                    _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.$t('farm-club-deals.valid-thru')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('farm-club-deals.deal-affects')), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(farmClubDeals).deals, (deal) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: deal.id
                    }, [
                      _createElementVNode("th", null, _toDisplayString(_unref(formatValue)(deal.bowler_name)), 1),
                      _createElementVNode("td", null, _toDisplayString(_unref(formatValue)(deal.club_name)) + " (" + _toDisplayString(_unref(formatValue)(deal.club_abbreviation)) + ") ", 1),
                      _createElementVNode("td", null, _toDisplayString(_unref(formatValue)(deal.farm_club_name)) + " (" + _toDisplayString(_unref(formatValue)(deal.farm_club_abbreviation)) + ") ", 1),
                      _createElementVNode("td", _hoisted_4, _toDisplayString(_unref(formatDate)(new Date(deal.valid_start_date), false, true)), 1),
                      _createElementVNode("td", _hoisted_5, _toDisplayString(_unref(formatDate)(new Date(deal.valid_end_date), false, true)), 1),
                      _createElementVNode("td", null, _toDisplayString(_unref(formatValue)(deal.deal_affects)), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }))
  ]))
}
}

})